export default __webpack_public_path__ + "static/flag-no-40d5f8c78ec79d1fe76cb1a919c07735.svg";